import Header        from "./Components/Header/header";
import Presentation from './Components/Presentation/presentation';
import FirstStep   from './Components/Steps/FirstStep/FirstStep';
import SecondStep from './Components/Steps/SecondStep/SecondStep';
import ThirdStep from "./Components/Steps/ThirdStep/ThirdStep";
import FourStep from './Components/Steps/FourStep/FourStep';
import FiveStep from './Components/Steps/FiveStep/FiveStep';

const App = () => {
  return(
    <main>
      <Header/>
      <Presentation/>
      <FirstStep/>
      <SecondStep/>
      <ThirdStep/>
      <FourStep/>
      <FiveStep/>
    </main>
  )
}

export default App;
